/* ── Crown & Culture Theme JS — FINAL FIX ── */
(function () {
  'use strict';

  /* ── ANNOUNCEMENT BAR ── */
  const bar = document.getElementById('announcement-bar');
  const barTxt = document.getElementById('announce-text');
  if (bar && barTxt) {
    const msgs = (bar.dataset.msgs || '').split('|||').map(s => s.trim()).filter(Boolean);
    if (msgs.length > 1) {
      let i = 0;
      setInterval(() => {
        barTxt.style.opacity = '0';
        setTimeout(() => { i = (i + 1) % msgs.length; barTxt.textContent = msgs[i]; barTxt.style.opacity = '1'; }, 400);
      }, 6000);
    }
  }

  /* ── HEADER SCROLL ── */
  const hdr = document.getElementById('site-header');
  if (hdr) {
    const isHome = document.body.classList.contains('template-index');
    const tick = () => {
      if (window.scrollY > 60) { hdr.classList.add('site-header--scrolled'); hdr.classList.remove('site-header--solid'); }
      else { hdr.classList.remove('site-header--scrolled'); if (!isHome) hdr.classList.add('site-header--solid'); }
    };
    tick();
    window.addEventListener('scroll', tick, { passive: true });
  }

  /* ── MOBILE MENU ── */
  const hbtn = document.getElementById('hamburger-btn');
  const mnav = document.getElementById('mobile-nav');
  if (hbtn && mnav) {
    hbtn.addEventListener('click', () => {
      const open = !mnav.hidden;
      mnav.hidden = open;
      hbtn.setAttribute('aria-expanded', String(!open));
    });
  }

  const FREE_SHIP = 10000;

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(r => r.json());
  }

  function addItem(variantId, qty) {
    const id = parseInt(variantId, 10);
    if (!id || isNaN(id)) return Promise.reject(new Error('Invalid variant ID: ' + variantId));
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: id, quantity: parseInt(qty, 10) || 1 })
    }).then(r => {
      if (!r.ok) return r.json().then(err => { throw new Error(err.description || 'Add to cart failed'); });
      return r.json();
    });
  }

  function changeItem(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: parseInt(qty, 10) })
    }).then(r => r.json()).then(c => renderCart(c));
  }

  function clearCart() {
    return fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(r => r.json()).then(c => renderCart(c));
  }

  function renderCart(cart) {
    const count = cart.item_count;
    document.querySelectorAll('#cart-badge, #cd-count').forEach(el => {
      el.textContent = count;
      if (el.id === 'cart-badge') el.style.display = count > 0 ? 'flex' : 'none';
    });
    const total = document.getElementById('cd-total');
    if (total) total.textContent = money(cart.total_price);
    const fill = document.getElementById('ship-bar-fill');
    const shipTxt = document.getElementById('ship-bar-text');
    if (fill) fill.style.width = Math.min(100, (cart.total_price / FREE_SHIP) * 100) + '%';
    if (shipTxt) {
      if (cart.total_price >= FREE_SHIP) {
        shipTxt.innerHTML = '<span style="color:#10b981;font-weight:700">✓ FREE EXPRESS SHIPPING UNLOCKED</span>';
      } else {
        shipTxt.innerHTML = 'Add <strong style="color:#C5A059">' + money(FREE_SHIP - cart.total_price) + '</strong> more for FREE shipping';
      }
    }
    const empty = document.getElementById('cd-empty');
    const itemsEl = document.getElementById('cd-items');
    const foot = document.getElementById('cd-foot');
    if (cart.items.length === 0) {
      if (empty) empty.style.display = 'flex';
      if (itemsEl) itemsEl.style.display = 'none';
      if (foot) foot.style.display = 'none';
    } else {
      if (empty) empty.style.display = 'none';
      if (foot) foot.style.display = 'block';
      if (itemsEl) {
        itemsEl.style.display = 'flex';
        itemsEl.innerHTML = cart.items.map(item => {
          const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
          return `<div class="cart-item">
            ${item.image ? `<img src="${item.image}" alt="${item.title}" class="cart-item__img" loading="lazy">` : '<div class="cart-item__img" style="background:#111"></div>'}
            <div class="cart-item__info">
              <div>
                <p class="cart-item__title">${item.title}</p>
                ${variant ? `<p class="cart-item__meta">${variant}</p>` : ''}
              </div>
              <div class="cart-item__bot">
                <div class="qty-ctrl">
                  <button class="qty-ctrl__btn" data-key="${item.key}" data-action="dec">−</button>
                  <span class="qty-ctrl__val">${item.quantity}</span>
                  <button class="qty-ctrl__btn" data-key="${item.key}" data-action="inc">+</button>
                </div>
                <span class="cart-item__price">${money(item.line_price)}</span>
              </div>
              <button class="cart-item__rm" data-key="${item.key}">REMOVE</button>
            </div>
          </div>`;
        }).join('');
        itemsEl.querySelectorAll('[data-action]').forEach(b => {
          b.addEventListener('click', () => {
            const itm = cart.items.find(i => i.key === b.dataset.key);
            if (!itm) return;
            changeItem(b.dataset.key, b.dataset.action === 'inc' ? itm.quantity + 1 : Math.max(0, itm.quantity - 1));
          });
        });
        itemsEl.querySelectorAll('.cart-item__rm').forEach(b => {
          b.addEventListener('click', () => changeItem(b.dataset.key, 0));
        });
      }
    }
  }

  fetchCart().then(renderCart).catch(err => console.error('Cart error:', err));

  const drawer = document.getElementById('cart-drawer');
  const backdrop = document.getElementById('cart-backdrop');

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    if (backdrop) backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetchCart().then(renderCart);
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.getElementById('cart-btn')?.addEventListener('click', openCart);
  document.getElementById('cart-close')?.addEventListener('click', closeCart);
  document.getElementById('cd-continue')?.addEventListener('click', closeCart);
  backdrop?.addEventListener('click', closeCart);
  document.getElementById('cd-clear')?.addEventListener('click', clearCart);

  function doATC(btn, qty) {
    const vid = btn.dataset.vid || btn.dataset.variantId;
    if (!vid) { console.error('No variant ID on button', btn); return; }
    btn.disabled = true;
    const def = btn.querySelector('.atc-default, .qa-default');
    const added = btn.querySelector('.atc-added, .qa-added');
    addItem(vid, qty || 1).then(() => fetchCart()).then(cart => {
      renderCart(cart);
      if (def) def.style.display = 'none';
      if (added) added.style.display = 'inline-flex';
      btn.classList.add('is-added');
      openCart();
      setTimeout(() => {
        if (def) def.style.display = '';
        if (added) added.style.display = 'none';
        btn.classList.remove('is-added');
        btn.disabled = false;
      }, 2200);
    }).catch(err => { console.error('ATC error:', err); alert('Could not add to cart: ' + err.message); btn.disabled = false; });
  }

  const mainAtc = document.getElementById('main-atc');
  if (mainAtc) {
    mainAtc.addEventListener('click', () => doATC(mainAtc, parseInt(document.getElementById('qty-val')?.textContent || '1', 10)));
  }
  const stickyBtn = document.getElementById('sticky-atc-btn');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', () => {
      if (mainAtc) stickyBtn.dataset.vid = mainAtc.dataset.vid;
      doATC(stickyBtn, parseInt(document.getElementById('qty-val')?.textContent || '1', 10));
    });
  }

  document.addEventListener('click', e => {
    const btn = e.target.closest('.pcard__qa-btn, .pcard__mobile-add');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    if (btn.dataset.hasSizes === 'true') {
      const ov = document.getElementById('so-' + btn.dataset.pid);
      if (ov) { ov.classList.add('is-open'); ov.setAttribute('aria-hidden', 'false'); }
    } else { doATC(btn, 1); }
  });

  document.addEventListener('click', e => {
    const sz = e.target.closest('.pcard__size-overlay .sz-btn');
    if (!sz) return;
    e.preventDefault(); e.stopPropagation();
    doATC(sz, 1);
    const ov = sz.closest('.pcard__size-overlay');
    if (ov) { ov.classList.remove('is-open'); ov.setAttribute('aria-hidden', 'true'); }
  });

  document.addEventListener('click', e => {
    const c = e.target.closest('[data-cancel]');
    if (!c) return;
    const ov = document.getElementById('so-' + c.dataset.cancel);
    if (ov) { ov.classList.remove('is-open'); ov.setAttribute('aria-hidden', 'true'); }
  });

  const galleryMain = document.getElementById('gallery-main');
  const zoomWrap = document.getElementById('zoom-wrap');
  const zoomHint = document.getElementById('zoom-hint');
  let zoomed = false;
  if (galleryMain && zoomWrap) {
    galleryMain.addEventListener('click', e => {
      if (e.target.closest('button')) return;
      zoomed = !zoomed;
      zoomWrap.style.transform = zoomed ? 'scale(1.85)' : 'scale(1)';
      zoomWrap.style.transition = 'transform 0.4s ease';
      zoomWrap.style.transformOrigin = 'center center';
      galleryMain.style.cursor = zoomed ? 'zoom-out' : 'zoom-in';
      if (zoomHint) zoomHint.textContent = zoomed ? 'CLICK TO RESET' : 'CLICK TO OPTICAL ZOOM';
    });
  }
  document.querySelectorAll('.gallery__thumb').forEach(t => {
    t.addEventListener('click', () => {
      const idx = parseInt(t.dataset.thumb, 10);
      document.querySelectorAll('.gallery__img').forEach((img, i) => {
        const active = i === idx;
        img.classList.toggle('gallery__img--active', active);
        img.style.opacity = active ? '1' : '0';
        img.style.zIndex = active ? '2' : '1';
      });
      document.querySelectorAll('.gallery__thumb').forEach(th => th.classList.toggle('gallery__thumb--active', th === t));
      zoomed = false;
      if (zoomWrap) zoomWrap.style.transform = 'scale(1)';
      if (galleryMain) galleryMain.style.cursor = 'zoom-in';
      if (zoomHint) zoomHint.textContent = 'CLICK TO OPTICAL ZOOM';
    });
  });

  const qtyVal = document.getElementById('qty-val');
  document.getElementById('qty-minus')?.addEventListener('click', () => { if (qtyVal) qtyVal.textContent = Math.max(1, parseInt(qtyVal.textContent, 10) - 1); });
  document.getElementById('qty-plus')?.addEventListener('click', () => { if (qtyVal) qtyVal.textContent = parseInt(qtyVal.textContent, 10) + 1; });

  document.querySelectorAll('.color-btn').forEach(b => {
    b.addEventListener('click', () => {
      document.querySelectorAll('.color-btn').forEach(x => { x.classList.remove('color-btn--active'); x.setAttribute('aria-pressed', 'false'); });
      b.classList.add('color-btn--active'); b.setAttribute('aria-pressed', 'true');
      const nameEl = document.getElementById('sel-color');
      if (nameEl) nameEl.textContent = b.dataset.color.toUpperCase();
      if (mainAtc) mainAtc.dataset.vid = b.dataset.vid;
      if (stickyBtn) stickyBtn.dataset.vid = b.dataset.vid;
    });
  });

  document.querySelectorAll('.pdp-sizes .sz-btn').forEach(b => {
    b.addEventListener('click', () => {
      if (b.classList.contains('sz-btn--out')) return;
      document.querySelectorAll('.pdp-sizes .sz-btn').forEach(x => { x.classList.remove('sz-btn--active'); x.setAttribute('aria-pressed', 'false'); });
      b.classList.add('sz-btn--active'); b.setAttribute('aria-pressed', 'true');
      const nameEl = document.getElementById('sel-size');
      if (nameEl) nameEl.textContent = b.dataset.size;
      if (mainAtc) mainAtc.dataset.vid = b.dataset.vid;
      if (stickyBtn) stickyBtn.dataset.vid = b.dataset.vid;
      const meta = document.getElementById('sticky-meta');
      if (meta) meta.textContent = 'SIZE: ' + b.dataset.size;
    });
  });

  const stickyBar = document.getElementById('sticky-atc');
  if (stickyBar && mainAtc) {
    window.addEventListener('scroll', () => {
      stickyBar.style.transform = mainAtc.getBoundingClientRect().bottom < 0 ? 'translateY(0)' : 'translateY(100%)';
    }, { passive: true });
  }

  document.querySelectorAll('.acc__trig').forEach(t => {
    t.addEventListener('click', () => {
      const open = t.getAttribute('aria-expanded') === 'true';
      const body = document.getElementById(t.getAttribute('aria-controls'));
      t.setAttribute('aria-expanded', String(!open));
      if (body) body.classList.toggle('acc__body--closed', open);
    });
  });

  const sizeModal = document.getElementById('size-modal');
  document.getElementById('size-guide-open')?.addEventListener('click', () => { if (sizeModal) { sizeModal.classList.add('is-open'); sizeModal.setAttribute('aria-hidden', 'false'); } });
  document.getElementById('size-modal-close')?.addEventListener('click', () => { if (sizeModal) { sizeModal.classList.remove('is-open'); sizeModal.setAttribute('aria-hidden', 'true'); } });
  document.getElementById('modal-bg')?.addEventListener('click', () => { if (sizeModal) { sizeModal.classList.remove('is-open'); sizeModal.setAttribute('aria-hidden', 'true'); } });

  const vid = document.getElementById('promo-vid') || document.querySelector('.promo-video__bg');
  const playBtn = document.getElementById('vid-play-btn');
  const muteBtn = document.getElementById('vid-mute-btn');
  if (vid && playBtn) {
    playBtn.addEventListener('click', () => {
      const paused = vid.paused;
      paused ? vid.play() : vid.pause();
      playBtn.querySelector('.ico-pause').style.display = paused ? '' : 'none';
      playBtn.querySelector('.ico-play').style.display = paused ? 'none' : '';
    });
  }
  if (vid && muteBtn) {
    muteBtn.addEventListener('click', () => {
      vid.muted = !vid.muted;
      muteBtn.querySelector('.ico-muted').style.display = vid.muted ? '' : 'none';
      muteBtn.querySelector('.ico-sound').style.display = vid.muted ? 'none' : '';
    });
  }

  const ddBtn = document.getElementById('sort-dd-btn');
  const ddMenu = document.getElementById('sort-menu');
  if (ddBtn && ddMenu) {
    ddBtn.addEventListener('click', () => { ddMenu.style.display = ddMenu.style.display !== 'none' ? 'none' : 'block'; });
    document.addEventListener('click', e => { if (!ddBtn.contains(e.target) && !ddMenu.contains(e.target)) ddMenu.style.display = 'none'; });
  }
  document.getElementById('sort-sel')?.addEventListener('change', e => { const url = new URL(window.location.href); url.searchParams.set('sort_by', e.target.value); window.location.href = url.toString(); });

  const priceRange = document.getElementById('price-range');
  const priceDisplay = document.getElementById('price-display');
  if (priceRange && priceDisplay) {
    priceRange.addEventListener('input', () => {
      const max = parseInt(priceRange.value, 10);
      priceDisplay.textContent = '$' + max + ' USD';
      document.querySelectorAll('#pgrid .pcard').forEach(card => {
        const p = parseFloat(card.querySelector('.pcard__price')?.textContent?.replace(/[^0-9.]/g, '') || '9999');
        card.style.display = p <= max ? '' : 'none';
      });
    });
  }

  document.getElementById('footer-sub-form')?.addEventListener('submit', function (e) {
    e.preventDefault();
    const input = document.getElementById('footer-email');
    if (!input?.value) return;
    const success = document.getElementById('footer-sub-success');
    if (success) { this.style.display = 'none'; success.style.display = 'flex'; setTimeout(() => { success.style.display = 'none'; this.style.display = ''; if (input) input.value = ''; }, 4000); }
  });

  document.getElementById('scroll-top')?.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      closeCart();
      if (sizeModal) { sizeModal.classList.remove('is-open'); sizeModal.setAttribute('aria-hidden', 'true'); }
    }
  });

})();